import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  emoji: '🌱',
  title: 'Plan 21 Días Detox Hepático',
  value: '$27'
}, {
  emoji: '🥤',
  title: 'Jugos y Batidos para un Hígado Sano',
  value: '$17'
}, {
  emoji: '🚫',
  title: 'Guía Visual de Alimentos Prohibidos',
  value: '$17'
}];
export function Bonuses() {
  return <section className="py-20 bg-brand-bg" data-id="element-15">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-17">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-18">
            <Gift className="w-4 h-4" data-id="element-19" />
            Solo por hoy
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-20">
            🎁 Bonos Exclusivos de Regalo
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-21">
            Si compras hoy, además del recetario completo, recibes estos 3 bonos
            sin costo adicional.
          </p>
        </motion.div>

        <div className="space-y-4 mb-10" data-id="element-22">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-brand-primary/10" data-id="element-23">
              <div className="flex-shrink-0 w-14 h-14 bg-brand-primary/10 rounded-xl flex items-center justify-center" data-id="element-24">
                <span className="text-3xl leading-none" aria-hidden="true" data-id="element-25">
                  {bonus.emoji}
                </span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-26">
                <span className="block text-xs font-bold uppercase tracking-wider text-brand-accent mb-1" data-id="element-27">
                  Bono {index + 1}
                </span>
                <h3 className="text-base md:text-lg font-bold text-gray-900 leading-snug" data-id="element-28">
                  {bonus.title}
                </h3>
              </div>
              <div className="flex-shrink-0 text-right" data-id="element-29">
                <span className="block text-gray-400 line-through text-sm" data-id="element-30">
                  {bonus.value}
                </span>
                <span className="inline-block bg-brand-accent/15 text-brand-dark font-extrabold px-3 py-1 rounded-full text-sm" data-id="element-31">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-primary text-white rounded-2xl p-6 text-center" data-id="element-32">
          <p className="text-lg md:text-xl font-medium" data-id="element-33">
            Valor total de los bonos:{' '}
            <span className="line-through text-brand-bg/60" data-id="element-34">$61</span>
            <span className="mx-2 text-brand-bg/60" data-id="element-35">→</span>
            <span className="text-2xl font-extrabold text-orange-400" data-id="element-36">
              HOY GRATIS
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}